module.exports = __webpack_public_path__ + "static/media/vehicle.3c81d212.svg";